import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { Col, Row } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { GET_DASHBOARD_V2_PERFORMANCE } from 'actions/dashboardV2';
import Card from 'components/inputs/Card';
import Loader from 'components/general/Loader';

const MetricCard = ({ title, yesterday, lastWeek, last30d, unit }) => (
  <Card>
    <div style={{ padding: '8px 4px' }}>
      <h6 style={{ fontWeight: 600, marginBottom: 12 }}>{title}</h6>
      <div style={{ display: 'flex', justifyContent: 'space-between', gap: 8 }}>
        {[
          { label: 'Yesterday', value: yesterday },
          { label: 'Last Week', value: lastWeek },
          { label: 'Last 30 Days', value: last30d },
        ].map(({ label, value }) => (
          <div key={label} style={{ textAlign: 'center', flex: 1 }}>
            <div style={{ fontSize: 20, fontWeight: 700 }}>
              {value != null ? `${value}${unit}` : '—'}
            </div>
            <div style={{ fontSize: 11, color: '#888', marginTop: 2 }}>{label}</div>
          </div>
        ))}
      </div>
    </div>
  </Card>
);

const PerformanceMetrics = () => {
  const dispatch = useDispatch();
  const { performance, isPerformanceLoading } = useSelector((state) => state.dashboardV2);

  useEffect(() => {
    dispatch({ type: GET_DASHBOARD_V2_PERFORMANCE.REQUEST });
  }, [dispatch]);

  if (isPerformanceLoading || !performance) {
    return (
      <Card>
        <div style={{ minHeight: 120, position: 'relative' }}>
          <Loader />
        </div>
      </Card>
    );
  }

  return (
    <Row>
      <Col md={4}>
        <MetricCard
          title="Avg Revenue per Session (₹)"
          yesterday={performance.yesterday?.avgRevenue}
          lastWeek={performance.lastWeek?.avgRevenue}
          last30d={performance.last30d?.avgRevenue}
        />
      </Col>
      <Col md={4}>
        <MetricCard
          title="Avg Session Duration"
          yesterday={performance.yesterday?.avgDurationMin}
          lastWeek={performance.lastWeek?.avgDurationMin}
          last30d={performance.last30d?.avgDurationMin}
          unit=" min"
        />
      </Col>
      <Col md={4}>
        <Card>
          <div style={{ padding: '8px 4px' }}>
            <h6 style={{ fontWeight: 600, marginBottom: 12 }}>Peak Usage Hours</h6>
            <div style={{ display: 'flex', justifyContent: 'space-between', gap: 8 }}>
              {[
                { label: 'Yesterday', value: performance.yesterday?.peakHour },
                { label: 'Last Week', value: performance.lastWeek?.peakHour },
                { label: 'Last 30 Days', value: performance.last30d?.peakHour },
              ].map(({ label, value }) => (
                <div key={label} style={{ textAlign: 'center', flex: 1 }}>
                  <div style={{ fontSize: 14, fontWeight: 700 }}>{value || '—'}</div>
                  <div style={{ fontSize: 11, color: '#888', marginTop: 2 }}>{label}</div>
                </div>
              ))}
            </div>
          </div>
        </Card>
      </Col>
    </Row>
  );
};

MetricCard.propTypes = {
  title: PropTypes.string,
  yesterday: PropTypes.number,
  lastWeek: PropTypes.number,
  last30d: PropTypes.number,
  unit: PropTypes.string,
};

MetricCard.defaultProps = {
  unit: '',
};

export default PerformanceMetrics;
